// extracted by mini-css-extract-plugin
export var dropdownContainer = "_if-0";
export var leftAlign = "_if-4";
export var listItem = "_if-2";
export var listItemWrapper = "_if-1";
export var operationText = "_if-3";